"use client";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { resolveSlotSport } from "@/lib/conditions/sport-aware-slot";

export function SportAwareSlot({
  defaultSport,
  bySport,
}: {
  defaultSport: string;
  bySport: Record<string, React.ReactNode>;
}) {
  const param = useShallowSearchParam("sport");
  const active = resolveSlotSport(param, defaultSport, Object.keys(bySport));
  return <>{bySport[active] ?? bySport[defaultSport] ?? null}</>;
}
